<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="student.thaistudent==1">ยืนยันการติดต่อขอรับปริญญาบัตร</strong>
              <strong v-else>The way to obtain Certificate</strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <b-row v-if="student.thaistudent==1">
              <b-col sm="1"></b-col>
              <b-col sm="11"><strong>{{ graduate_txt }}</strong></b-col>
            </b-row>

            <b-row v-else>
              <b-col sm="1"></b-col>
              <b-col sm="11"><strong>{{ graduateeng_txt }}</strong></b-col>
            </b-row>

            <b-row>
              <b-col sm="2"></b-col>
              <b-col sm="10">-{{ other_txt }}</b-col>
            </b-row>
            <b-row><b-col sm="12">  </b-col>
            </b-row>
            <b-row><b-col sm="12">  </b-col>
            </b-row>
<!--            <div v-if="student.thaistudent==1">-->
<!--              {{ graduate_txt }}<br>-->
<!--              &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp- {{ other_txt }}<br>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              {{ graduateeng_txt }}<br>-->
<!--              &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp- {{ other_txt }}<br>-->
<!--            </div>-->
            <div v-if="current_paid==1" align="center"><br>


              <font color="green" v-if="student.thaistudent==1"><strong>สถานะ: ชำระเงินแล้ว<br></strong></font>
              <font color="green" v-if="student.thaistudent==0"><strong>Status: Paid already<br></strong></font>
<!--              <font color="red">-->
<!--                ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์-->
<!--                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 7 วันทำการ-->
<!--                <br><u>หมายเหตุ</u> : สามารถตรวจสอบ หมายเลขไปรษณีย์การจัดส่งปริญญาบัตร ได้ที่ระบบเอกสารทางการศึกษา เมนู การขอเอกสาร-->
<!--                <br><br>The Registrar Division will send the degree certificate by post,-->
<!--                <br>after the commencement ceremony is finished within 7 working days.-->
<!--                <br><u>Remarks</u> : You can check the degree certificate postal number via e-Academic Document, Request Document menu.-->
<!--              </font>-->
              <font color="#00008b">
                <br>กรณีชำระค่าธรรมเนียมการจัดส่งปริญญาบัตรแล้ว แต่ได้ดำเนินการเปลี่ยนแปลงเป็นเข้ารับพระราชทานปริญญาบัตร
                <br>จะไม่สามารถคืนค่าธรรมเนียมการส่งไปรษณีย์ได้
              </font>
              <br>
              <font color="red">
                <br>ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์
                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 7 วันทำการ
                <br><u>หมายเหตุ</u> : สามารถตรวจสอบหมายเลขไปรษณีย์การจัดส่งปริญญาบัตร ได้ที่ระบบเอกสารทางการศึกษา <a href="https://regdoc.mfu.ac.th"  target="_blank">(https://regdoc.mfu.ac.th)</a> เมนูการขอเอกสาร
                <br>
                <font color="#00008b">
                  <br>If you have already paid the fee for mailing but later changed to attend the commencement ceremony, the fee is non-refundable.
                  <br>
                </font>
                <br>The Registrar Division will send the degree certificate by post,
                <br>after the commencement ceremony is finished within 7 working days.
                <br><u>Remarks</u> : You can check the tracking number via the e-Academic Document <a href="https://regdoc.mfu.ac.th"  target="_blank">(https://regdoc.mfu.ac.th)</a>, Request Document menu.
              </font>
            </div>
            <!--            <div v-if="student.thaistudent==1">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp3. จัดส่งทางไปรษณีย์ โดยให้จัดส่งแบบ-->
            <!--              (โปรดเลือก)-->
            <!--            </div>-->
            <!--            <div v-if="student.thaistudent==0">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp3. By post<br>-->
            <!--              &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp-->
            <!--              -Domestic-->
            <!--            </div>-->

            <div v-if="selected_post=='11' || selected_post=='12'" align="center">
              <font color="red">แสดงหนังสือยืนยันการขอรับปริญญาบัตร พร้อมบัตรประจำตัวนักศึกษาหรือบัตรประจำตัวประชาชน
                <br>หรือหนังสือเดินทาง ต่อเจ้าหน้าที่เพื่อติดต่อขอรับปริญญาบัตร
                <br>ได้ที่ส่วนทะเบียนและประมวลผล ตั้งแต่วันที่ 16 มีนาคม พ.ศ. 2569 เวลา 9.00 น. เป็นต้นไป
                <br>สอบถามข้อมูลเกี่ยวกับการจัดส่งปริญญาเบอร์ติดต่อ 053 916433/ 053- 916546 /053-916547


                <br><br>Please show a confirmation letter for obtaining a degree certificate
                <br>with student ID card or passport to the staff for contacting to obtain a degree certificate
                <br>at the registrar division after March 16,2026 at 9:00 a.m. onwards.
                <br>For more information about a degree certificate delivery, contact number 053-916433 / 053-916546 /
                053-916547.


              </font>
            </div>
            <div v-if="(selected_post=='21' || selected_post=='22' || selected_post=='31' )&& current_paid==0"
                 align="center">
              <font color="red">ส่วนทะเบียนและประมวลผล จะดำเนินการจัดส่งให้ทางไปรษณีย์
                <br>หลังเสร็จพิธีพระราชทานปริญญาบัตร ภายใน 7 วันทำการ
                <br><u>หมายเหตุ</u> : สามารถตรวจสอบ หมายเลขไปรษณีย์การจัดส่งปริญญาบัตร ได้ที่ระบบเอกสารทางการศึกษา เมนู การขอเอกสาร
                <br>
                <br>The Registrar Division will send the degree certificate by post,
                <br>after the commencement ceremony is
                finished within 7 working days.
                <br><u>Remarks</u> : You can check the degree certificate postal number via e-Academic Document, Request Document menu.
              </font>
            </div>
          </b-card>
          <b-card v-if="(selected_post ==21 || selected_post==22)&& current_paid==0" header-class="redmfu">
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ที่อยู่ในการจัดส่ง</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>Address</strong>
            </div>


            <b-row>
              <b-col sm="6">
                <b-form-group label="ชื่อ" :label-cols="4" v-if="student.thaistudent==1">
                  {{ current_name }}
                </b-form-group>
                <b-form-group label="Name" :label-cols="4" v-else>
                  {{ current_name }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="นามสกุล" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_surname }}
                </b-form-group>
                <b-form-group label="Surname" :label-cols="2" v-else>
                  {{ current_surname }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="จังหวัด" :label-cols="4" v-if="student.thaistudent==1">
                  {{ current_province_name }}
                </b-form-group>
                <b-form-group label="Province" :label-cols="4" v-else>
                  {{ current_province_name }}
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="อำเภอ" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_district_name }}
                </b-form-group>
                <b-form-group label="District" :label-cols="2" v-else>
                  {{ current_province_name }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ตำบล" :label-cols="4" v-if="student.thaistudent==1">
                  {{ current_subdistrict_name }}
                </b-form-group>
                <b-form-group label="Subdistrict" :label-cols="4" v-else>
                  {{ current_subdistrict_name }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="รหัสไปรษณีย์" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_zipcode }}
                </b-form-group>
                <b-form-group label="Postcode" :label-cols="2" v-else>
                  {{ current_zipcode }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="บ้านเลขที่" :label-cols="4" v-if="student.thaistudent==1">
                  {{ current_add }}
                </b-form-group>
                <b-form-group label="Address number" :label-cols="4" v-else>
                  {{ current_add }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="หมู่" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_moo }}
                </b-form-group>
                <b-form-group label="Moo" :label-cols="2" v-else>
                  {{ current_moo }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="หมู่บ้าน" :label-cols="4" v-if="student.thaistudent==1"  >
                  {{ current_village }}
                </b-form-group>
                <b-form-group label="Village" :label-cols="4" v-else>
                  {{ current_village }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="อาคาร/ตึก" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_building }}
                </b-form-group>
                <b-form-group label="Building" :label-cols="2" v-else>
                  {{ current_building }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="ซอย" :label-cols="4" v-if="student.thaistudent==1">
                  {{ current_lane }}
                </b-form-group>
                <b-form-group label="Soi" :label-cols="4" v-else>
                  {{ current_lane }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="ถนน" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_road }}
                </b-form-group>
                <b-form-group label="Road" :label-cols="2" v-else>
                  {{ current_road }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์มือถือ(ปัจจุบัน)" :label-cols="4" v-if="student.thaistudent==1">
                  {{ current_tel }}
                </b-form-group>
                <b-form-group label="Telephone" :label-cols="4" v-else>
                  {{ current_tel }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_tel_home }}
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" v-else>
                  {{ current_tel_home }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4">
                  {{ current_fax }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2">
                  {{ current_email }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4">
                  {{ current_fb }}
                </b-form-group>
              </b-col>
            </b-row>

            <div slot="footer" v-if="current_paid==0" align="center">
<!--              {{ AAA }} <br>-->
<!--              {{ BBB }}<br>-->
<!--              {{ CCC }}-->
<!--              https://regstd.mfu.ac.th/debt/ipaymentp == ตัวจริง-->
              <form class="form-horizontal" role="form" :action="txt_url" method="post">
                <input type="hidden" name="channel" value="document">
                <input type="hidden" name="std" :value="AAA">
                <input type="hidden" name="urlback" :value="BBB">
                <input type="hidden" name="lang" :value="CCC">
                <input type="hidden" name="lockselect" value="1">
                <button class="btn btn-success" type="submit" >
                  <i class="fa fa-money"></i>&nbsp;&nbsp;
                  <div align="center" v-if="thai_student==1">ชำระเงิน </div>
                  <div v-else>Payment </div>
                </button>&nbsp;&nbsp;&nbsp;
                <b-button type="reset"   variant="warning" v-if="current_paid==0" @click="onEditAddress">
                  <i class="fa fa-arrow-circle-o-left"></i>
                  <div v-if="thai_student==1">แก้ไขที่อยู่</div>
                  <div v-else> Edit Address</div>
                </b-button>
              </form>
            </div>

          </b-card>
          <b-card v-if="student.thaistudent==0 && selected_post==31" header-class="redmfu">
            <div slot="header" v-if="student.thaistudent==1">
              <strong>ที่อยู่ในการจัดส่ง</strong>
            </div>
            <div slot="header" v-if="student.thaistudent==0">
              <strong>Address</strong>
            </div>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Country" :label-cols="4">
                  {{ current_country_name }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Name" :label-cols="4">
                  {{ current_name }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Surname" :label-cols="2">
                  {{ current_surname }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Adress" :label-cols="2">
                  {{ current_add }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Mobile" :label-cols="4">
                  {{ current_tel }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="โทรศัพท์บ้าน" :label-cols="2" v-if="student.thaistudent==1">
                  {{ current_tel_home }}
                </b-form-group>
                <b-form-group label="Home Phone" :label-cols="2" v-else>
                  {{ current_tel_home }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Fax" :label-cols="4">
                  {{ current_fax }}
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Email" :label-cols="2">
                  {{ current_email }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Facebook" :label-cols="4">{{ current_fb }}
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer" class="text-center" v-if="current_paid==0">
<!--              {{ AAA }} <br>-->
<!--              {{ BBB }}<br>-->
<!--              {{ CCC }}-->
              <form class="form-horizontal" role="form" :action="txt_url" method="post">
                <input type="hidden" name="channel" value="document">
                <input type="hidden" name="std" :value="AAA">
                <input type="hidden" name="urlback" :value="BBB">
                <input type="hidden" name="lang" :value="CCC">
                <input type="hidden" name="lockselect" value="1">
                <button class="btn btn-success" type="submit" v-if="thai_student==1">
                  <i class="fa fa-money"></i>&nbsp;&nbsp;ชำระเงิน
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </button>
                <button class="btn btn-success" type="submit" v-if="thai_student==0">
                  <i class="fa fa-money"></i>&nbsp;&nbsp;Payment
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </button> &nbsp;&nbsp;&nbsp;
                <b-button type="reset" size="md" class="mr-2" variant="warning" v-if="current_paid==0" @click="onEditAddress">
                  <i class="fa fa-arrow-circle-o-left"></i> Edit Address
                </b-button>
              </form>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!--      <div slot="footer" class="text-center" v-if="current_paid==0">-->
      <!--        {{ AAA }} <br>-->
      <!--        {{ BBB }}<br>-->
      <!--        {{ CCC }}-->
      <!--        <form class="form-horizontal" role="form" action="https://regstd.mfu.ac.th/debt/ipaymentp" method="post">-->
      <!--          <input type="hidden" name="channel" value="document">-->
      <!--          <input type="hidden" name="std" :value="AAA">-->
      <!--          <input type="hidden" name="urlback" :value="BBB">-->
      <!--          <input type="hidden" name="lang" :value="CCC">-->
      <!--          <input type="hidden" name="lockselect" value="1">-->
      <!--          <button class="btn btn-info" type="submit" v-if="thai_student==1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ชำระเงิน-->
      <!--            (ยังไม่พร้อมให้เทส)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
      <!--          </button>-->
      <!--          <button class="btn btn-info" type="submit" v-if="thai_student==0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Payment-->
      <!--            (ยังไม่พร้อมให้เทส)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
      <!--          </button> &nbsp;&nbsp;&nbsp;-->
      <!--          <b-button type="reset" size="md" class="mr-2" variant="danger" v-if="current_paid==0">-->
      <!--            <i class="fa fa-ban"></i> Reset-->
      <!--          </b-button>-->
      <!--        </form>-->
      <!--      </div>-->
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      student: {},
      // std_id: "",
      // sex: "",
      AAA: "",
      BBB: "",
      CCC: "",
      thai_student: "",
      current_postpone:0,
      numEror: 0,
      current_erorrtxt: "",
      current_paymenttxt: "",
      selected_post: "",
      selected_post1: "",
      selected_post2: "",
      graduate_txt: "",
      graduateeng_txt: "",
      other_txt: "",

      dangerModal: false,
      items: [],
      items1: [],
      items2: [],
      actionUpdate: 10,
      actionStudent: 10,
      levelid: "",
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      select_country: "",
      select_country1: "",
      select_province: 0,
      provinceItems: [],
      select_district: 0,
      districtItems: [],
      select_subdistrict: 0,
      subdistrictItems: [],
      countryItems: [],
      txt_url:"",
      current_tel: "",
      current_tel_home: "",
      current_add: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_building: "",
      current_province: "",
      current_province_name: "",
      current_district: "",
      current_district_name: "",
      current_subdistrict: "",
      current_subdistrict_name: "",
      current_name: "",
      current_surname: "",
      current_country: "",
      current_country_name: "",
      current_fax: "",
      current_email: "",
      current_authorized: "",
      current_fb: "",
      current_year: "",
      current_paid: 0,
    };
  },
  components: {
    vSelect
  },
  computed: {
    validation_no() {
      if (this.current_add != null) {
        return this.current_add.length >= 2 && this.current_add.length < 50
      } else {
        return false;
      }
    },

    validation_village() {
      if (this.current_village != null) {
        return this.current_village.length >= 1 && this.current_village.length < 50
      } else {
        return false;
      }
    }, validation_build() {
      if (this.current_building != null) {
        return this.current_building.length >= 1 && this.current_building.length < 50
      } else {
        return false;
      }
    },
    validation_road() {
      if (this.current_road != null) {
        return this.current_road.length >= 1 && this.current_road.length < 50
      } else {
        return false;
      }
    },
    validation_soi() {
      if (this.current_lane != null) {
        return this.current_lane.length >= 1 && this.current_lane.length < 50
      } else {
        return false;
      }
    },
    validation_moo() {
      if (this.current_moo != null) {
        return this.current_moo.length >= 1 && this.current_moo.length < 50
      } else {
        return false;
      }
    },
    validation_add() {
      if (this.current_address != null) {
        return this.current_address.length >= 10 && this.current_address.length < 500
      } else {
        return false;
      }
    }

  },
  methods: {
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // console.log("validEmail==",email,re.test(email));
      return re.test(email);
    },
    validPhone() {
      // var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;
      if (this.current_tel.match(phoneno10) || this.current_tel.match(phoneno11) || this.current_tel.match(phoneno12) || this.current_tel.match(phoneno14)
        || this.current_tel.match(phoneno15) || this.current_tel.match(phoneno16) || this.current_tel.match(phoneno17) || this.current_tel.match(phoneno18)
        || this.current_tel.match(phoneno19) || this.current_tel.match(phoneno20) || this.current_tel.match(phoneno21) || this.current_tel.match(phoneno22)
        || this.current_tel.match(phoneno23) || this.current_tel.match(phoneno24) || this.current_tel.match(phoneno25) || this.current_tel.match(phoneno26)
        || this.current_tel.match(phoneno27) || this.current_tel.match(phoneno28) || this.current_tel.match(phoneno29) || this.current_tel.match(phoneno30)) {
        // console.log("--------true---------",this.current_tel);
        return true;
      } else {
        // console.log("--------false---------",this.current_tel);
        return false;
      }
    },
    getCountry(thaistudent) {
      api
        .getCountryNoThaiPost(thaistudent)
        .then(res => {
          this.countryItems = res.data.data;
          // console.log("res==", res);
        })
        .catch(err => {
          console.log("getCountry", err.toString());
        });
    },
    selectCountryOnchange: function () {
      this.select_country = this.select_country1.COUNTRYID;
      // console.log("select_country==", this.select_country);
      this.current_country_name = this.select_country1.COUNTRYNAME;
      //  api
      //   .getCountryById(this.select_country,this.student.thaistudent)
      //   .then(res => {
      //     this.current_country_name = res.data.data[0].COUNTRYNAME;
      //   })
      //   .catch(err => {
      //     // console.log(2);
      //     console.log("getCountryById", err.toString());
      //   });
    },
    getProvinceAll(thaistudent) {
      api
        .getProvinceAll(thaistudent)
        .then(res => {
          this.provinceItems = res.data.data;
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getProvinceId(thaistudent) {
      api
        .getProvinceById(thaistudent)
        .then(res => {
          this.current_province_name = res.data.data[0].PROVINCENAME;
          // console.log("current_province_name", res);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getDistrictId(id, thaistudent) {
      api
        .getDistrictByDistrictid(id, thaistudent)
        .then(res => {
          this.current_district_name = res.data.data[0].DISTRICTNAME;
          // console.log("current_district_name", this.current_district_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    getSubDistrictId(id, thaistudent) {
      // console.log("id==",id)
      api
        .getSubDistrictBySubdistricid(id, thaistudent)
        .then(res => {
          this.current_subdistrict_name = res.data.data[0].SUB_DISTRICTNAME;
          // console.log("current_subdistrict_name", this.current_subdistrict_name);
        })
        .catch(err => {

          console.log("getProvince", err.toString());
        });
    },
    onloadDistrictById: async function () {
      api
        .getDistrictByid(this.select_province, this.student.thaistudent)
        .then(res => {
          this.districtItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadDistrictById", err.toString());
        });
    },
    onloadSubDistrictById: async function () {
      api
        .getSubDistrictByid(this.select_district, this.student.thaistudent)
        .then(res => {
          this.subdistrictItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadSubDistrictById", err.toString());
        });
    },
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.student.thaistudent)
        .then(res => {
          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
        })
        .catch(err => {
          console.log("onloadZipcodeById", err.toString());
        });
    },
    selectProvinceOnchange: function () {
      this.onloadDistrictById(this.select_province);
      this.getProvinceId(this.select_province);
      console.log("select_province981== ", this.select_province);
      this.select_subdistrict = 0;
    },
    selectDistrictOnchange: function () {
      this.current_district = this.select_district;
      console.log("894== ", this.select_district);
      this.getDistrictId(this.select_district);
      this.onloadSubDistrictById(this.select_district);
    },
    selectSubDistrictOnchange: function () {
      this.getSubDistrictId(this.select_subdistrict);
      this.onloadZipcodeById(this.select_subdistrict);
    },
    getStudentGeneral(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("getStudentGeneral res== ", res);
          if (res.data.data.length == 1) {

            this.actionStudent = 1;
            var currentSt = res.data.data[0];

            this.current_name = currentSt.STUDENTNAME;
            this.current_surname = currentSt.STUDENTSURNAME;
            this.current_tel = currentSt.CURRENT_TEL;
            this.current_country = currentSt.CURRENT_COUNTRY;
            this.current_email = currentSt.CURRENT_EMAIL;
            this.current_add = currentSt.CURRENT_NO;
            this.current_village = currentSt.CURRENT_VILLAGE;
            this.current_building = currentSt.CURRENT_BUILDING;
            this.current_moo = currentSt.CURRENT_MOO;
            this.current_lane = currentSt.CURRENT_LANE;
            this.current_road = currentSt.CURRENT_ROAD;
            this.current_zipcode = currentSt.CURRENT_ZIPCODE;
            this.select_provinceid = currentSt.CURRENT_PROVINCEID;
            //this.select_district = currentSt.CURRENT_DISTRICT; เอาออกก่อน เดี๋ยวตำบลไม่ขึ้น
            this.current_subdistrict = currentSt.CURRENT_SUBDISTRICT;
            this.current_country = currentSt.CURRENT_COUNTRY;
            if ((this.selected_post == 21) || (this.selected_post == 22)) {
              // console.log("selected_post== ",this.selected_post);
              this.getProvinceAll(this.student.thaistudent);
              this.select_province = currentSt.CURRENT_PROVINCEID;
              // console.log("select_province== ",currentSt.CURRENT_PROVINCEID);
              this.select_district = currentSt.CURRENT_DISTRICT;
              this.onloadDistrictById(this.select_province);
              this.select_subdistrict = currentSt.CURRENT_SUBDISTRICT;
              this.onloadSubDistrictById(this.select_district);
            }
            if ((this.current_province_name != '') && (this.current_province_name != 0) && (this.current_province_name != null) && (this.current_province_name != undefined)) {
              this.getProvinceId(this.select_province, this.student.thaistudent);
            }
            if ((this.current_district_name != '') && (this.current_district_name != 0) && (this.current_district_name != null) && (this.current_district_name != undefined)) {
              // console.log("942== ",this.select_district);
              this.getDistrictId(this.select_district, this.student.thaistudent);
            }
            if ((this.current_subdistrict_name != '') && (this.current_subdistrict_name != 0) && (this.current_subdistrict_name != null) && (this.current_subdistrict_name != undefined)) {
              this.getSubDistrictId(this.select_subdistrict, this.student.thaistudent);
            }

            this.getCountry(this.student.thaistudent);
            this.select_country = currentSt.CURRENT_COUNTRY;
            // this.student.current_country_name=currentSt.CURRENT_COUNTRY_NAME;
            this.current_country_name = currentSt.CURRENT_COUNTRY_NAME;

            // }

          } else {
            this.actionStudent = 0;
          }
          console.log("getStudentGeneral==", this.actionUpdate);
          return this.actionStudent;
        })
        .catch(err => {
          this.actionStudent = 10;
          console.log("getStudentGeneral", err.toString());
          this.$router.push("/Logout");
        });
    },
    getPostPay(studentid, thaistudent) {
      api
        .getStudentPostPay(studentid, thaistudent)
        .then(res => {
           // console.log("getPostPay==", res);
          this.AAA = res.data.data[0].STDREF;
        })
        .catch(err => {
          console.log("getStudentPostPay", err.toString());
          return 0;
        });
    },
    getGraduateStatus(studentid) {
      api
        .getStudentGraduateStatus(studentid)
        .then(res => {
          this.graduate_txt = res.data.data[0].BYTEDES;
          this.graduateeng_txt = res.data.data[0].BYTEDES_ENG;
          this.other_txt = res.data.data[0].OTHER;
          // console.log("getGraduateStatus==", res);
        })
        .catch(err => {
          console.log("getStudentGraduateStatus==", err.toString());
        });
    },
    getCurrentStudent(student) {
      api
        .getStudentPostById(student)
        .then(res => {
          // console.log(" res==", res);
          var currentSt = res.data.data[0];
          this.current_paid = res.data.data[0].PAIDAALREADY;
          if (res.data.data.length == 1) {
            if (res.data.data[0].POST_STATUS == null) {
              this.actionUpdate = 0;
              // console.log("964 getCurrentStudent ไม่มี",this.actionUpdate,res);
            } else {
              this.actionUpdate = 1;
              // console.log(" getCurrentStudent มีข้อมูล",this.actionUpdate,res);
            }
            this.getGraduateStatus(student.studentid);
            // console.log("xxx==",student.studentid,student.thaistudent);
            this.getPostPay(student.studentid, student.thaistudent);
            // console.log("xxx==",this.actionUpdate);
            this.selected_post = currentSt.POST_STATUS;
            // console.log(" this.selected_post ",this.selected_post );
            if ((this.selected_post == 11) || (this.selected_post == null)) {
              this.getStudentGeneral(this.student.studentid);
            }
            if (this.selected_post == 12) {
              this.current_authorized = currentSt.POST_AUTHORIZED_PERSON;
              this.getStudentGeneral(this.student.studentid);
            }
            if ((this.selected_post == 21) || (this.selected_post == 22)) {

              this.current_name = currentSt.POST_FIRST_NAME;
              this.current_surname = currentSt.POST_LAST_NAME;
              this.current_add = currentSt.POST_ADD;
              this.getProvinceAll(this.thai_student);
              this.select_province = currentSt.POST_PROVICE;
              // console.log(" select_province==",currentSt.POST_PROVICE);
              this.current_province_name = currentSt.POST_PROVICE_NAME;
              this.onloadDistrictById(this.select_province);
              this.select_district = currentSt.POST_DISTRICT;
              // console.log(" select_district1094==",this.select_district);
              this.current_district_name = currentSt.POST_DISTRICT_NAME;
              this.select_subdistrict = currentSt.POST_TAMBON;
              // console.log("xx==", this.select_district)
              if (this.select_district != '')
                this.onloadSubDistrictById(this.select_district);
              this.current_subdistrict_name = currentSt.POST_TAMBON_NAME;
              this.current_zipcode = currentSt.POST_ZIPCODE;
              this.current_moo = currentSt.POST_MOO;
              this.current_village = currentSt.POST_BAN;
              this.current_building = currentSt.POST_BUILDING;
              this.current_lane = currentSt.POST_SOI;
              this.current_road = currentSt.POST_STREET;
              this.current_tel = currentSt.POST_TEL;
              this.current_tel_home = currentSt.POST_TEL_HOME;
              this.current_fax = currentSt.POST_FAX;
              this.current_email = currentSt.POST_EMAIL;
              this.current_fb = currentSt.POST_FACEBOOK;
            }
            if (this.selected_post == 31) {

              this.current_name = currentSt.POST_FIRST_NAME;
              this.current_surname = currentSt.POST_LAST_NAME;
              this.select_country = currentSt.POST_COUNTRY;
              this.select_country1 = currentSt.POST_COUNTRY_NAME;
              this.current_country_name = currentSt.POST_COUNTRY_NAME;
              // console.log("current_country_name== ",this.current_country_name);
              this.current_add = currentSt.POST_ADD;
              this.current_tel = currentSt.POST_TEL;
              this.current_tel_home = currentSt.POST_TEL_HOME;
              this.current_fax = currentSt.POST_FAX;
              this.current_email = currentSt.POST_EMAIL;
              this.current_fb = currentSt.POST_FACEBOOK;
            }
          } else {
            this.actionUpdate = 0;
            this.getStudentGeneral(this.std_id);
          }
          // console.log(" getCurrentStudent==", this.actionUpdate);
          return this.actionUpdate;
        })
        .catch(err => {
          console.log("getCurrentStudent 1139", err.toString());
          this.actionUpdate = 10;
          // this.$router.push("/Logout");

        });
    },
    onEditAddress() {
      this.$router.push("post");
    },
    nextPart() {
      if (this.selected_post == 11) { //ด้วยตนเอง
        this.$router.push("person");
      } else if (this.selected_post == 12) { //มอบฉันทะ
        this.$router.push("authorized");
      } else if (this.selected_post == 21) {
        this.$router.push("regispost");
      } else if (this.selected_post == 22) {
        this.$router.push("regispost");
      } else if (this.selected_post == 31) {
        this.$router.push("person");
      }
    },
    onCreateData(student) {
      // console.log("student==", student);
      api
        .postStudentPost(student)
        .then(res => {
          // console.log("res==", res);
          if (res.data.code == 200) {
            this.message = res.message;
            console.log("insert ผ่าน");
          }
          // console.log("insert ผ่าน");
          // this.nextPart();
        })
        .catch(err => {
          console.log("onCreateData", err.toString());
          // this.$router.push("/Logout");
        });
    },
    onUpdateData(student) {
      api
        .updateStudentPost(student)
        .then(res => {
          if (res.data.code == 200) {
            this.message = res.message;
            console.log("update ผ่าน");
            // this.dangerModalPayment=true;
          }
          // console.log("update ผ่าน");
          // this.nextPart();
        })
        .catch(err => {
          console.log("onUpdateData error", err.toString());
          // this.$router.push("/Logout");
        })
    },
    getPosttype(columname, thaistudent, start, finish) {
      api
        .getPostTypeBetween(columname, thaistudent, start, finish)
        .then(res => {
          // console.log("res==",res);
          if (start == 11) {
            this.items = res.data.data;

          } else if (start == 21) {
            this.items1 = res.data.data;
          } else if (start == 31) {
            this.items2 = res.data.data;
          }
          // console.log("res==",res);
        })
        .catch(err => {
          console.log("getPosttype", err.toString());
        });
    },
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }

    this.txt_url='https://regstd.mfu.ac.th/debt/ipaymentp';  //จริง แก้ 3 ไฟล์ main-main70-postdetail
    // this.txt_url="https://regstdtest.mfu.ac.th/debt/ipaymentp";//ตัวเทส
    this.student.studentid = this.$store.state.user.studentid;
    this.student.thaistudent = this.$store.state.user.thaistudent;
    this.thai_student = this.$store.state.user.thaistudent;
    this.current_postpone = this.$store.state.user.postpone_status;
    this.student.levelid = this.$store.state.user.levelid;
    this.student.year = 2566;
    // console.log("student==",student)
    this.actionUpdate = this.getCurrentStudent(this.student);
    // this.BBB = "http://localhost:8080/#/Main";
    if (this.current_postpone==1){
      this.BBB = "https://ccr.mfu.ac.th/#/Main70";
    }else {
      this.BBB = "https://ccr.mfu.ac.th/#/Main";
     }
    if (this.thai_student == 1) {
      this.CCC = 'th';
    } else {
      this.CCC = 'en';
    }
    this.getPosttype('POST_STATUS', this.student.thaistudent, 11, 12);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 21, 22);
    this.getPosttype('POST_STATUS', this.student.thaistudent, 31, 31);
    this.getCountry(this.student.thaistudent);
    this.getProvinceAll(this.student.thaistudent);

  }
};
</script>
<style>

</style>
